"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _contentType = require("@insided/shared/utils/contentType");

var _UserContext = require("@insided/shared/services/UserContext");

var _CategoryTopicListView = _interopRequireDefault(require("@insided/deprecated-preact-components/widget-category-and-topic-stream/CategoryTopicListView.sync"));

var _ProductAreasDropdown = _interopRequireDefault(require("../TopicCreation/ProductAreasDropdown"));

var _IdeaStatusDropdown = _interopRequireDefault(require("./components/IdeaStatusDropdown"));

var _BugStatusDropdown = _interopRequireDefault(require("./components/BugStatusDropdown"));

var _CategoryContentTypeFilters = _interopRequireDefault(require("./components/CategoryContentTypeFilters"));

var _service = require("./service");

var _activityTopicListHeader = _interopRequireDefault(require("../activity/activity-topic-list-header"));

var _classnames = _interopRequireDefault(require("classnames"));

var _globals = require("@insided/shared/utils/globals");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var DEFAULT_PAGE_SIZE = 25;
var DEFAULT_PAGE = 1;
var DEFAULT_SORT = {
  sticky: 'desc',
  lastActivityAt: 'desc'
}; // Display order for content type tabs

var CONTENT_TYPE_TABS_ORDER = [_contentType.CONTENT_TYPE_QUESTION, _contentType.CONTENT_TYPE_CONVERSATION, _contentType.CONTENT_TYPE_IDEA, _contentType.CONTENT_TYPE_PRODUCT_UPDATE, _contentType.CONTENT_TYPE_ARTICLE];
/**
 * Pure reducer function for applying topic fetch results to state.
 * Isolated from component for testability and clarity.
 */

function applyTopicsReducer(prevState, payload) {
  var result = payload.result,
      action = payload.action;
  var topics = result.topics,
      authors = result.authors,
      total = result.total;

  if (action === 'replace') {
    return _objectSpread(_objectSpread({}, prevState), {}, {
      topicsData: {
        topics: topics,
        authors: authors,
        totalTopicsCount: total
      },
      ui: _objectSpread(_objectSpread({}, prevState.ui), {}, {
        isLoading: false
      })
    });
  }

  if (action === 'merge') {
    return _objectSpread(_objectSpread({}, prevState), {}, {
      topicsData: {
        topics: [].concat((0, _toConsumableArray2.default)(prevState.topicsData.topics), (0, _toConsumableArray2.default)(topics)),
        authors: _objectSpread(_objectSpread({}, prevState.topicsData.authors), authors),
        totalTopicsCount: total
      },
      ui: _objectSpread(_objectSpread({}, prevState.ui), {}, {
        isLoading: false
      })
    });
  }

  console.error('Unknown action type in applyTopicsReducer:', action);
  return prevState;
}

var CategoryTopicList = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CategoryTopicList, _Component);

  var _super = _createSuper(CategoryTopicList);

  function CategoryTopicList() {
    var _this$props$topics, _this$props$authors, _this$props$totalTopi, _this$props$initialPa;

    var _this;

    (0, _classCallCheck2.default)(this, CategoryTopicList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      ui: {
        activeContentType: 'all',
        isLoading: false
      },
      topicsData: {
        topics: (_this$props$topics = _this.props.topics) !== null && _this$props$topics !== void 0 ? _this$props$topics : [],
        authors: (_this$props$authors = _this.props.authors) !== null && _this$props$authors !== void 0 ? _this$props$authors : {},
        totalTopicsCount: (_this$props$totalTopi = _this.props.totalTopicsCount) !== null && _this$props$totalTopi !== void 0 ? _this$props$totalTopi : 0
      },
      filters: {
        contentType: [],
        productArea: []
      },
      pagination: {
        pageSize: DEFAULT_PAGE_SIZE,
        page: (_this$props$initialPa = _this.props.initialPage) !== null && _this$props$initialPa !== void 0 ? _this$props$initialPa : DEFAULT_PAGE
      },
      sort: DEFAULT_SORT
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFilterChange", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(filterKey) {
        var ui;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                ui = _this.state.ui;

                if (!(filterKey === ui.activeContentType || ui.isLoading)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _this.setState(function (prevState) {
                  return {
                    ui: _objectSpread(_objectSpread({}, prevState.ui), {}, {
                      isLoading: true,
                      activeContentType: filterKey
                    }),
                    filters: {
                      productArea: [],
                      contentType: filterKey === 'all' ? [] : [filterKey]
                    },
                    pagination: _objectSpread(_objectSpread({}, prevState.pagination), {}, {
                      page: 1
                    })
                  };
                }, function () {
                  return _this.loadTopics({
                    action: 'replace'
                  });
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadTopics", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(payload) {
        var requestUrl, query, result;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                requestUrl = _this.props.requestUrl;
                query = _this.buildQuery();
                _context2.prev = 2;
                _context2.next = 5;
                return (0, _service.fetchTopics)(requestUrl, query);

              case 5:
                result = _context2.sent;

                _this.setState(function (prevState) {
                  return applyTopicsReducer(prevState, {
                    result: result,
                    action: payload.action
                  });
                });

                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](2);
                console.error('Error loading topics: ', _context2.t0);

                _this.setState(function (prevState) {
                  return {
                    ui: _objectSpread(_objectSpread({}, prevState.ui), {}, {
                      isLoading: false
                    })
                  };
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 9]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onIdeaStatusFilterChange", function (statuses) {
      _this.setState(function (prevState) {
        return {
          filters: _objectSpread(_objectSpread({}, prevState.filters), {}, {
            ideationStatus: statuses.length > 0 ? statuses : undefined
          }),
          pagination: _objectSpread(_objectSpread({}, prevState.pagination), {}, {
            page: 1
          })
        };
      }, function () {
        return _this.loadTopics({
          action: 'replace'
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onBugStatusFilterChange", function (status) {
      _this.setState(function (prevState) {
        return {
          filters: _objectSpread(_objectSpread({}, prevState.filters), {}, {
            bugStatus: status.name
          }),
          pagination: _objectSpread(_objectSpread({}, prevState.pagination), {}, {
            page: 1
          })
        };
      }, function () {
        return _this.loadTopics({
          action: 'replace'
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onProductAreaFilterChange", function (productAreas) {
      _this.setState(function (prevState) {
        return {
          filters: _objectSpread(_objectSpread({}, prevState.filters), {}, {
            productArea: productAreas.map(function (pa) {
              return String(pa);
            })
          }),
          pagination: _objectSpread(_objectSpread({}, prevState.pagination), {}, {
            page: 1
          })
        };
      }, function () {
        return _this.loadTopics({
          action: 'replace'
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSortChange", function (sortType) {
      _this.setState(function (prevState) {
        return {
          sort: (0, _defineProperty2.default)({
            sticky: 'desc'
          }, sortType, 'desc'),
          pagination: _objectSpread(_objectSpread({}, prevState.pagination), {}, {
            page: 1
          }),
          ui: _objectSpread(_objectSpread({}, prevState.ui), {}, {
            isLoading: true
          })
        };
      }, function () {
        return _this.loadTopics({
          action: 'replace'
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showMoreHandler", function () {
      _this.setState(function (prevState) {
        return {
          pagination: _objectSpread(_objectSpread({}, prevState.pagination), {}, {
            page: prevState.pagination.page + 1
          })
        };
      }, function () {
        return _this.loadTopics({
          action: 'merge'
        });
      });
    });
    return _this;
  }

  (0, _createClass2.default)(CategoryTopicList, [{
    key: "buildQuery",
    value: function buildQuery() {
      var _this$props = this.props,
          isCategoryContainer = _this$props.isCategoryContainer,
          categoryId = _this$props.categoryId;
      var _this$state = this.state,
          filters = _this$state.filters,
          pagination = _this$state.pagination,
          sort = _this$state.sort;

      if (!categoryId) {
        return {
          sort: sort,
          filters: filters,
          pagination: pagination
        };
      }

      if (isCategoryContainer) {
        return {
          sort: sort,
          filters: filters,
          pagination: pagination,
          containerIds: [categoryId]
        };
      }

      return {
        sort: sort,
        pagination: pagination,
        filters: _objectSpread(_objectSpread({}, filters), {}, {
          category: [categoryId]
        })
      };
    }
    /**
     * Returns content types that are both supported by the category AND accessible via module permissions.
     * Ideas/Product Updates require module access, others are always enabled if in supportedContentTypes.
     */

  }, {
    key: "getEnabledContentTypes",
    value: function getEnabledContentTypes() {
      var _this$props2 = this.props,
          accessibleModuleContentTypes = _this$props2.accessibleModuleContentTypes,
          _this$props2$supporte = _this$props2.supportedContentTypes,
          supportedContentTypes = _this$props2$supporte === void 0 ? [] : _this$props2$supporte;
      return supportedContentTypes.filter(function (type) {
        return type !== _contentType.CONTENT_TYPE_IDEA && type !== _contentType.CONTENT_TYPE_PRODUCT_UPDATE || accessibleModuleContentTypes.includes(type);
      });
    }
  }, {
    key: "getContentTypeFilters",
    value: function getContentTypeFilters(isBugContentTypeEnabled) {
      var _this$props$showAllFi = this.props.showAllFilter,
          showAllFilter = _this$props$showAllFi === void 0 ? true : _this$props$showAllFi;
      var enabledContentTypes = this.getEnabledContentTypes(); // If 0-1 types enabled, hide ALL tabs including "All Topics"

      if (enabledContentTypes.length <= 1) {
        return [];
      }

      var contentTypes = (0, _toConsumableArray2.default)(enabledContentTypes).sort(function (a, b) {
        var indexA = CONTENT_TYPE_TABS_ORDER.indexOf(a);
        var indexB = CONTENT_TYPE_TABS_ORDER.indexOf(b); // If not found in order array, place at the end

        return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
      });
      var filters = [];

      if (showAllFilter) {
        filters.push({
          key: 'all',
          label: (0, _preact.h)(_phrase.default, {
            p: "category.filter.all"
          }),
          enabled: true
        });
      }

      contentTypes.forEach(function (contentType) {
        // Show "Bugs" instead of "Conversations" when bugContentType is enabled
        var isBugType = isBugContentTypeEnabled && contentType === 'conversation';
        filters.push({
          key: contentType,
          label: isBugType ? (0, _preact.h)(_phrase.default, {
            p: "category.filter.bug"
          }) : (0, _preact.h)(_phrase.default, {
            p: "category.filter.".concat((0, _contentType.getLegacyContentType)(contentType))
          }),
          enabled: true
        });
      });
      return filters;
    }
  }, {
    key: "renderHeaderSlot",
    value: function renderHeaderSlot() {
      var isEmpty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var isBugContentTypeEnabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var productAreas = this.props.productAreas;
      var _this$state2 = this.state,
          ui = _this$state2.ui,
          topicsData = _this$state2.topicsData;
      var activeContentType = ui.activeContentType;
      var isAllTab = activeContentType === 'all';
      var isIdeaTab = activeContentType === _contentType.CONTENT_TYPE_IDEA;
      var isProductUpdateTab = activeContentType === _contentType.CONTENT_TYPE_PRODUCT_UPDATE;
      var isBugTab = isBugContentTypeEnabled && activeContentType === _contentType.CONTENT_TYPE_CONVERSATION;
      var hasProductAreas = (productAreas === null || productAreas === void 0 ? void 0 : productAreas.length) > 0;
      var enabledContentTypes = this.getEnabledContentTypes();
      var isIdeasEnabled = enabledContentTypes.includes(_contentType.CONTENT_TYPE_IDEA);
      var isProductUpdatesEnabled = enabledContentTypes.includes(_contentType.CONTENT_TYPE_PRODUCT_UPDATE); // Determine what filters to show on the "all" (Topics) tab

      var onlyIdeasEnabled = isIdeasEnabled && !isProductUpdatesEnabled;
      var bothEnabled = isIdeasEnabled && isProductUpdatesEnabled;
      var showIdeaStatusOnAllTab = isAllTab && (onlyIdeasEnabled || bothEnabled);
      var showProductAreasOnAllTab = isAllTab && hasProductAreas && (isIdeasEnabled || isProductUpdatesEnabled); // Ideas/Bugs always have status filters; Product Updates only if product areas exist

      var showAdditionalFilter = isIdeaTab || isBugTab || isProductUpdateTab && hasProductAreas || showIdeaStatusOnAllTab || showProductAreasOnAllTab;
      return (0, _preact.h)("div", null, showAdditionalFilter && (0, _preact.h)("div", {
        className: "content-type-filters__additional",
        key: "additional-filter-".concat(activeContentType)
      }, (0, _preact.h)("span", {
        className: "content-type-filters__additional-label"
      }, isBugTab ? (0, _preact.h)(_phrase.default, {
        p: "category.filter.additional.bug"
      }) : isAllTab ? (0, _preact.h)(_phrase.default, {
        p: "category.filter.additional.filterBy"
      }) : (0, _preact.h)(_phrase.default, {
        p: "category.filter.additional.".concat(activeContentType)
      }), ":"), ((isIdeaTab || isProductUpdateTab) && hasProductAreas || showProductAreasOnAllTab) && (0, _preact.h)(_ProductAreasDropdown.default, {
        productAreasV2: productAreas,
        onChange: this.onProductAreaFilterChange,
        value: this.state.filters.productArea
      }), (isIdeaTab || showIdeaStatusOnAllTab) && (0, _preact.h)(_IdeaStatusDropdown.default, {
        key: "idea-status-dropdown",
        onChange: this.onIdeaStatusFilterChange,
        placeholder: (0, _preact.h)(_phrase.default, {
          p: "category.filter.additional.ideaStatusAll"
        }),
        value: this.state.filters.ideationStatus
      }), isBugTab && (0, _preact.h)(_BugStatusDropdown.default, {
        key: "bug-status-dropdown",
        onChange: this.onBugStatusFilterChange,
        placeholder: (0, _preact.h)(_phrase.default, {
          p: "category.filter.additional.bugStatusAll"
        }),
        value: this.state.filters.bugStatus
      })), !isEmpty && (0, _preact.h)(_activityTopicListHeader.default, {
        totalTopicsCount: topicsData.totalTopicsCount,
        onSortChange: this.onSortChange,
        className: "list__items--header--no-padding"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          attachmentCdn = _this$props3.attachmentCdn,
          initialTotalCount = _this$props3.totalTopicsCount;
      var _this$state3 = this.state,
          ui = _this$state3.ui,
          topicsData = _this$state3.topicsData;
      var isLoading = ui.isLoading,
          activeContentType = ui.activeContentType;
      var topics = topicsData.topics,
          authors = topicsData.authors,
          totalTopicsCount = topicsData.totalTopicsCount; // Hide content type tabs when a category has no topics

      var hasContent = initialTotalCount > 0;
      return (0, _preact.h)(_globals.ModulesContext.Consumer, null, function (modules) {
        var isBugContentTypeEnabled = modules.includes('bugContentType');
        var filters = hasContent ? _this2.getContentTypeFilters(isBugContentTypeEnabled) : [];
        return (0, _preact.h)("div", {
          className: "category-topic-list"
        }, (0, _preact.h)(_CategoryContentTypeFilters.default, {
          activeContentType: activeContentType,
          filters: filters,
          onFilterChange: /*#__PURE__*/function () {
            var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(filterKey) {
              return _regenerator.default.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return _this2.handleFilterChange(filterKey);

                    case 2:
                      return _context3.abrupt("return", _context3.sent);

                    case 3:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3);
            }));

            return function (_x3) {
              return _ref3.apply(this, arguments);
            };
          }(),
          isLoading: isLoading,
          isBugContentTypeEnabled: isBugContentTypeEnabled
        }), (0, _preact.h)("div", {
          className: (0, _classnames.default)('category-topic-list__content', {
            'category-topic-list__content--loading': isLoading
          })
        }, (0, _preact.h)(_CategoryTopicListView.default, {
          headerSlot: _this2.renderHeaderSlot(!topics || topics.length === 0, isBugContentTypeEnabled),
          topics: topics,
          attachmentCdn: attachmentCdn,
          authors: authors,
          hasMore: Number(totalTopicsCount) > topics.length,
          onShowMore: _this2.showMoreHandler,
          isLoading: isLoading
        }), isLoading && (0, _preact.h)("div", {
          className: "category-topic-list__loading"
        }, (0, _preact.h)("div", {
          className: "loader"
        }), (0, _preact.h)("span", {
          className: "text--meta"
        }, (0, _preact.h)(_phrase.default, {
          p: "Loading topics..."
        })))));
      });
    }
  }]);
  return CategoryTopicList;
}(_preact.Component);

var _default = (0, _UserContext.withUserContext)(CategoryTopicList);

exports.default = _default;
var cssAnchorName = 'category-topic-list';
exports.cssAnchorName = cssAnchorName;